import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ai-accounts-summaries',
  templateUrl: './ai-accounts-summaries.component.html',
  styleUrls: ['./ai-accounts-summaries.component.css'],
})
export class AiAccountsSummariesComponent implements OnInit {
  @Input() summariesYearAccount: number = null;
  @Input() aiAccountsSummaries: Record<string, Array<any>> = {};

  summaryURL: string = '';
  fullSummaryVisible: Record<string, boolean> = {};

  constructor() {}

  ngOnInit(): void {}

  getSummaryURL(pageNumber: number): string {
    if (!this.aiAccountsSummaries[this.summariesYearAccount][0]['pdf_url'])
      return '#';
    return (
      this.aiAccountsSummaries[this.summariesYearAccount][0]['pdf_url'] +
      '#page=' +
      pageNumber
    );
  }

  showFullDetails(yearAccount: number | string): void {
    const isVisible = this.fullSummaryVisible[yearAccount] || false;
    this.fullSummaryVisible = {
      ...this.fullSummaryVisible,
      [yearAccount]: !isVisible,
    };
  }

  isFullSummariesAvailable(bullet: Record<string, any>): boolean {
    return Object.keys(bullet).length > 0;
  }
}
